import { TextBoxSearchIcon } from './TextBoxSearchIcon';

/**
 * author: Austin Andrews
 * id 08B85EF9-81EC-4DEE-B1C7-1C14D4CBECA5
 * name text-box-search
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-box-search.svg
 * tags
 * - Files / Folders 
 */
export const FileDocumentBoxSearchIcon = TextBoxSearchIcon;
export default FileDocumentBoxSearchIcon